import { QueryFunctionContext } from '@tanstack/react-query'
import { KeywordsAutoSuggestService } from 'shared/services/KeywordsAutoSuggestService'

const DEFAULT_SUGGESTIONS_LIMIT = 5

export const querySearchSuggestions = (
  context: QueryFunctionContext<KeywordsAutoSuggest.DefaultAutoSuggestQuery>,
): Promise<KeywordsAutoSuggest.Response | null> => {
  const { queryKey } = context
  const [_, { galleryName, keyword, locale, limit, searchBackend }] = queryKey

  return KeywordsAutoSuggestService.getSuggestions({
    galleryName,
    keyword,
    locale,
    limit: limit || DEFAULT_SUGGESTIONS_LIMIT,
    searchBackend,
  })
}
